/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ── Bestsellers: shuffle and show random 8 on each page load ── */
document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('[data-section-type="featured-collection"]');
  if (!section) return;
  var list = section.querySelector('.product-list');
  if (!list) return;
  var items = Array.from(list.children);
  if (items.length <= 8) return;

  // Fisher-Yates shuffle
  for (var i = items.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = items[i];
    items[i] = items[j];
    items[j] = tmp;
  }

  // Hide all, show first 8
  items.forEach(function(el, idx) {
    if (idx < 8) {
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  });

  // Re-append in shuffled order
  items.forEach(function(el) {
    list.appendChild(el);
  });
});


/* ── MOTI: keep --header-height in sync so the sticky collection toolbar
   stays glued right under the header on mobile (it was measured only once
   at render time, which left a gap where products scrolled through). ── */
(function () {
  var last = -1;

  function headerEl() {
    return (
      document.querySelector('.shopify-section__header') ||
      document.querySelector('[id^="shopify-section-"][id$="__header"]') ||
      document.querySelector('header[role="banner"]') ||
      document.querySelector('.header')
    );
  }

  function sync() {
    var el = headerEl();
    if (!el) return;
    var h = Math.round(el.getBoundingClientRect().height);
    if (h > 0 && h !== last) {
      last = h;
      document.documentElement.style.setProperty('--header-height', h + 'px');
      document.documentElement.style.setProperty('--moti-header-h', h + 'px');
    }
  }

  function boot() {
    sync();
    setTimeout(sync, 150);
    setTimeout(sync, 400);
    setTimeout(sync, 1200);

    if (window.ResizeObserver) {
      var el = headerEl();
      if (el) {
        try {
          new ResizeObserver(sync).observe(el);
        } catch (e) {}
      }
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', sync);
  window.addEventListener('resize', sync, { passive: true });
  window.addEventListener('orientationchange', function () {
    setTimeout(sync, 250);
  });
  window.addEventListener('scroll', sync, { passive: true });
})();
